import { html } from 'lit';
import { OutlineElement } from '../outline-element/outline-element.ts';

// import baseStyles from '../../tailwind.base.css.lit';
import screens from './tokens/screens.tailwind.json';

const mobileScreens = ['xxs', 'xs', 'sm', 'md'];

/**
 * class Component
 *
 * Every component in this system inherits this class's methods.
 */
export default class QueryComponent extends OutlineElement {
  // static styles = [baseStyles];

  static get properties() {
    return {
      breakPoint: { type: String },
      breakPoints: { type: Array },
      isMobile: { type: Boolean },
    };
  }

  constructor() {
    super();
    this.breakPoint = '';
    this.breakPoints = Object.entries(screens).map(([key, value]) => {
      return { name: key, query: `(min-width:${value})` };
    });
    this.isMobile = true;
  }

  connectedCallback() {
    super.connectedCallback();
    this._getBreakPoint();
    window.addEventListener('resize', () => {
      this._getBreakPoint();
    });
  }

  _getBreakPoint() {
    let result = '';
    this.breakPoints.forEach(element => {
      if (window.matchMedia(element.query).matches) {
        result = element.name;
      }
    });

    this.breakPoint = result;
    this.isMobile = mobileScreens.includes(result);
  }

  /**
   * @param {xs|sm|md|lg|xl|xxl} screenSize
   * @param {min|max} query
   */
  _mediaQuery(screenSize, query = 'min') {
    let breakpoint = this.breakPoints.find(
      element => element.name === screenSize
    ).query;
    if (query === 'max') {
      const breakpointDigits = breakpoint.replace(/\D/g, '');
      breakpoint = breakpoint
        .replace('min', query)
        .replace(breakpointDigits, breakpointDigits - 1);
    }

    return window.matchMedia(breakpoint).matches;
  }

  /**
   * Render just the children of the element by default.
   */
  render() {
    return html`<slot></slot>`;
  }
}
